<!-- Standard bw-dialog shell — same shape as audit-detail-view / file-viewer-dialog.
     Header is <lib-page-header>, body fills the dialog with a meta-card +
     a snapshot section that scrolls independently for the Raw JSON. -->
<div class="bw-dialog gantt-event-dialog">

    <lib-page-header screenName="Gantt Event" [title]="'' + (item.title || 'Event Details')" backTo="">
        <mat-icon icon>event_note</mat-icon>
        <ng-container subtitle *ngIf="item.start">
            <span>{{ item.start | date:'medium' }}</span>
        </ng-container>
        <ng-container actions>
            <button mat-icon-button (click)="copyJSONToClipboard()" matTooltip="Copy JSON" aria-label="Copy JSON">
                <mat-icon>content_copy</mat-icon>
            </button>
        </ng-container>
    </lib-page-header>

    <!-- Body — meta-card stays put; only the inner snapshot-content scrolls. -->
    <div class="bw-body">

        <!-- Meta card — same shape as audit-detail-view's meta-card. -->
        <div class="meta-card">
            <div class="meta-row">
                <mat-icon class="meta-icon">tag</mat-icon>
                <span class="meta-label">ID</span>
                <span class="meta-value mono" [matTooltip]="'' + item.id">{{ item.id }}</span>
                <button mat-icon-button class="copy-btn" (click)="copyToClipboard()"
                        matTooltip="Copy ID" aria-label="Copy ID" [class.clicked]="copied">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
            <div class="meta-row">
                <mat-icon class="meta-icon">folder</mat-icon>
                <span class="meta-label">Group</span>
                <span class="meta-value">{{ item.group_id }}</span>
            </div>
            <div class="meta-row">
                <mat-icon class="meta-icon">view_day</mat-icon>
                <span class="meta-label">Type</span>
                <span class="meta-value">{{ item.type | titlecase }}</span>
            </div>
            <div class="meta-row">
                <mat-icon class="meta-icon">play_circle</mat-icon>
                <span class="meta-label">Start</span>
                <span class="meta-value">{{ item.start | date:'full' }}</span>
            </div>
            <div class="meta-row">
                <mat-icon class="meta-icon">stop_circle</mat-icon>
                <span class="meta-label">End</span>
                <span class="meta-value">{{ item.end | date:'full' }}</span>
            </div>
        </div>

        <!-- Snapshot section — same shape as audit-detail-view's Snapshot Data.
             Outer flexes to fill remaining body height; .snapshot-content is the
             scroll container, so the JSON tree gets its own scrollable region
             and the meta-card stays anchored at the top. -->
        <div class="snapshot-section">
            <div class="snapshot-body">
                <div class="snapshot-label">
                    <mat-icon class="snap-icon">data_object</mat-icon>
                    Raw JSON
                </div>
                <div class="snapshot-content">
                    <app-json-path-viewer [value]="jsonData"></app-json-path-viewer>
                </div>
            </div>
        </div>

    </div>
</div>
